import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size: number;
  color?: string;
};

const Property = ({ size, color }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 5H23V7H12V5ZM10 7V5C10 3.89543 10.8954 3 12 3H23C24.1046 3 25 3.89543 25 5V7C26.1046 7 27 7.89543 27 9V27H29C29.5523 27 30 27.4477 30 28C30 28.5523 29.5523 29 29 29H25H16H10H7H3C2.44771 29 2 28.5523 2 28C2 27.4477 2.44772 27 3 27H5V9C5 7.89543 5.89543 7 7 7H10ZM25 27H16V23C16 21.3431 14.6569 20 13 20C11.3431 20 10 21.3431 10 23V27H7L7 9H12H23H25V27ZM14 23V27H12V23C12 22.4477 12.4477 22 13 22C13.5523 22 14 22.4477 14 23ZM10 12C9.44772 12 9 12.4477 9 13C9 13.5523 9.44772 14 10 14H14C14.5523 14 15 13.5523 15 13C15 12.4477 14.5523 12 14 12H10ZM9 17C9 16.4477 9.44772 16 10 16H14C14.5523 16 15 16.4477 15 17C15 17.5523 14.5523 18 14 18H10C9.44772 18 9 17.5523 9 17ZM18 12C17.4477 12 17 12.4477 17 13C17 13.5523 17.4477 14 18 14H22C22.5523 14 23 13.5523 23 13C23 12.4477 22.5523 12 22 12H18ZM17 17C17 16.4477 17.4477 16 18 16H22C22.5523 16 23 16.4477 23 17C23 17.5523 22.5523 18 22 18H18C17.4477 18 17 17.5523 17 17ZM18 20C17.4477 20 17 20.4477 17 21C17 21.5523 17.4477 22 18 22H22C22.5523 22 23 21.5523 23 21C23 20.4477 22.5523 20 22 20H18Z"
        fill={color || tailwindConfig.theme.colors.gray[500]}
      />
    </svg>
  );
};

export default Property;
